module.exports = __webpack_public_path__ + "static/media/Pause.47c8b946.svg";